module.exports = __webpack_public_path__ + "img/2.28df8b4d.jpg";